var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader'),_c('Banner'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('h1',[_vm._v("Unauthorized!")]),_c('p',[_vm._v("We're having trouble verifying your identity.")]),_c('footer',[_vm._v(" Please contact "),_c('a',{attrs:{"href":"https://www.mirusresearch.com"}},[_vm._v("https://www.mirusresearch.com")]),_vm._v(" for further assistance. ")])])
}]

export { render, staticRenderFns }